module.exports = __webpack_public_path__ + "media/images/common/kuchi_1-7f7584c7c01fcd7fef2558c09e4f270a.gif";